import type { BreadcrumbLinkProps } from '@/components/Breadcrumbs/types';
import type { TaxonomyBreadcrumbParent } from '@/types/Taxonomy';

export const getBreadcrumbParents = ({
  data,
}: {
  data?: TaxonomyBreadcrumbParent[];
}): BreadcrumbLinkProps[] => {
  if (!data) {
    return [];
  }

  // NOTE: the array is sorted in place for performance reasons
  // Make a copy if it is used in other components
  const canonicalParents = [...data].sort((a, b) => b.order - a.order);

  const canonicalParentsLinks = canonicalParents?.map((item) => {
    const newItem = {
      id: item?.id?.toString() ?? item.url,
      label: item.name,
      slug: item.url,
      relative_url: item.url,
    };

    return newItem;
  });

  return canonicalParentsLinks;
};
